import { createGlobalStyle } from 'styled-components';
import styledReset from './styledReset';

const GlobalStyle = createGlobalStyle`
${styledReset};
*,
*::before,
*::after{
    box-sizing: border-box;
}
:root{
    --color-primary:#015c3b;
    --color-secondary:#e6e6e6;
    --color-tertiary:#333333;
    --color-background:#1e1e1e26;
    /* --color-tertiary:#cccccc; */
    --color-highlight:#4e6e29;
    --color-text:#555555;
    --color-white:#fff;
    --color-black:#000;
    --color-shadow:#ccccccb3;
}

::-webkit-scrollbar {
  width: 5px;
  background-color:#E6E6E6;
 
}

::-webkit-scrollbar-thumb {
  background: #000; 
  border-radius: 10px;
  height:20%;
}
`;

export default GlobalStyle;
